import configAuto from "./ConfigAuto";
import configEntzy from "./ConfigEntzy";

const CONFIG_AWS = {
  Auth: {
    Cognito: {
      region: configAuto.cognito.REGION,
      userPoolId: configAuto.cognito.USER_POOL_ID,
      userPoolClientId: configAuto.cognito.APP_CLIENT_ID,
      identityPoolId: configAuto.cognito.IDENTITY_POOL_ID,
      allowGuestAccess: true,
      loginWith: {
        email: true,
        oauth: {
          domain: configEntzy.APP_AUTH_DOMAIN,
          scopes: [
            "phone",
            "email",
            "profile",
            "openid",
            "aws.cognito.signin.user.admin",
          ],
          redirectSignIn: [configEntzy.APP_URL],
          redirectSignOut: [configEntzy.APP_URL],
          responseType: "code",
        },
      },
      rumAppMonitorId: configAuto.cognito.RUM_APP_MONITOR_ID,
    },
  },
  Storage: {
    read: {
      S3: {
        region: configAuto.s3.REGION,
        bucket: configAuto.s3.BUCKET,
      },
    },
    write: {
      S3: {
        region: configAuto.cognito.REGION,
        bucket: configAuto.s3.BUCKET.replace(
          configAuto.s3.REGION,
          configAuto.cognito.REGION,
        ),
      },
    },
  },
  API: {
    GraphQL: {
      region: configAuto.appsync.REGION,
      endpoint: configAuto.appsync.ENDPOINT,
      defaultAuthMode: configAuto.appsync.AUTH_TYPE,
    },
  },
};

export default CONFIG_AWS;
